import { X } from "@phosphor-icons/react";
import { SPORTS_LIST } from "@/lib/teams";
import SellerTypeahead from "@/components/SellerTypeahead";
import IconKey from "@/components/IconKey";

const SPORTS = SPORTS_LIST;

/**
 * Mobile filter drawer for the Browse page. Slides in from the bottom
 * on mobile, centred modal on md+. Pure UI — parent owns state.
 */
export default function BrowseFilterDrawer({ filters, setFilters, resetFilters, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-end md:items-center md:justify-center bg-black/70" onClick={onClose}>
      <div className="w-full md:max-w-lg bg-[#121212] border-t md:border border-white/10 max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="sticky top-0 bg-[#121212] border-b border-white/10 p-4 flex items-center justify-between">
          <h3 className="font-display font-black uppercase text-lg tracking-tight">Filters</h3>
          <button onClick={onClose} data-testid="filters-close" className="text-zinc-400"><X size={20} weight="bold" /></button>
        </div>
        <div className="p-4 space-y-5">
          <div>
            <label className="h57-label">Sport</label>
            <select className="h57-input" value={filters.sport} data-testid="filter-sport" onChange={(e) => setFilters({ ...filters, sport: e.target.value })}>
              <option value="">All</option>
              {SPORTS.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="h57-label">Brand</label>
              <input className="h57-input" data-testid="filter-brand" value={filters.brand} onChange={(e) => setFilters({ ...filters, brand: e.target.value })} placeholder="Topps" />
            </div>
            <div>
              <label className="h57-label">Year</label>
              <input type="number" className="h57-input" data-testid="filter-year" value={filters.year} onChange={(e) => setFilters({ ...filters, year: e.target.value })} placeholder="2024" />
            </div>
          </div>
          <div>
            <label className="h57-label">Seller (@username)</label>
            <SellerTypeahead
              value={filters.seller}
              onChange={(v) => setFilters((f) => ({ ...f, seller: v }))}
              testIdPrefix="filter-seller"
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="h57-label">Price Min</label>
              <input type="number" step="0.01" className="h57-input" data-testid="filter-price-min" value={filters.price_min} onChange={(e) => setFilters({ ...filters, price_min: e.target.value })} placeholder="0" />
            </div>
            <div>
              <label className="h57-label">Price Max</label>
              <input type="number" step="0.01" className="h57-input" data-testid="filter-price-max" value={filters.price_max} onChange={(e) => setFilters({ ...filters, price_max: e.target.value })} placeholder="9999" />
            </div>
          </div>
          <div>
            <label className="h57-label">Card Type</label>
            <div className="flex flex-wrap gap-2">
              {[
                ["base", "Base"],
                ["insert", "Insert"],
                ["variation", "Variation"],
                ["rookie", "Rookie"],
                ["autograph", "Auto"],
                ["relic", "Relic"],
                ["numbered", "Numbered"],
                ["ssp", "SSP"],
                ["sp", "SP"],
                ["graded", "Graded"],
                ["accepts_offers", "Accepts Offers"],
              ].map(([k, label]) => (
                <button
                  key={k}
                  onClick={() => setFilters({ ...filters, [k]: !filters[k] })}
                  data-testid={`filter-${k}`}
                  className={`h57-chip !py-2 !px-3 ${filters[k] ? "!border-[#FF5F1F] !text-[#FF5F1F]" : ""}`}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
          <div className="flex gap-3 pt-4">
            <button onClick={resetFilters} className="h57-btn-secondary flex-1" data-testid="filters-reset">Reset</button>
            <button onClick={onClose} className="h57-btn-primary flex-1" data-testid="filters-apply">Apply</button>
          </div>
          <IconKey testId="drawer-icon-key" />
        </div>
      </div>
    </div>
  );
}
